<template>
  <div>

    <b-row>
      <b-col>
        <h5>Filtrar por</h5>
      </b-col>
    </b-row>

    <b-row>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde">Fecha desde</label>
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range_created_at.startDate"
            :max="
              range_created_at.endDate == ''
                ? maxDate
                : range_created_at.endDate
            "
            @blur="changeDate()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta">Fecha hasta</label>
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range_created_at.endDate"
            :min="range_created_at.startDate"
            :max="maxDate"
            @blur="changeDate()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col v-if="role_id == 1 || role_id == 7">
        <b-form-group>
          <label class="mb-0">Responsable</label>
          <b-form-select v-model="staff_id_filter" @change="getFilterWallet()">
            <template slot="first">
              <option :value="null">-- Seleccione--</option>
            </template>
            <option v-for="item in lstStaffs" :key="item.id" :value="item.id">
              {{ item.name }} {{ item.last_name }} ({{ item.type_name }})
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Cliente</label>
          <b-form-input
            type="text"
            v-model="business_name_filter"
            @blur="getFilterWallet()"
            placeholder="Nombre del cliente"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="2">
        <b-form-group>
          <label class="mb-0">Orden de servicio</label>
          <b-form-select
            v-model="service_order_id_filter"
            @change="getFilterWallet()"
          >
            <template slot="first">
              <option :value="null">-- Seleccione --</option>
            </template>
            <option
              v-for="item in lstServiceOrder"
              :key="item.id"
              :value="item.id"
            >
              CONTRATO_{{ item.agreement_number }} - ORDEN_{{ item.number }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0">Fuente</label>
          <b-form-select v-model="source_id_filter" @change="getFilterWallet()">
            <template slot="first">
              <option :value="null">-- Seleccione --</option>
            </template>
            <option v-for="item in lstSource" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col sm="4">
        <b-form-group>
          <label class="mb-0">Departamento</label>
          <b-form-select
            v-model="zone_id_filter"
            @change="getCitiesByZone(zone_id_filter)"
          >
            <template slot="first">
              <option :value="null">-- Seleccione --</option>
            </template>

            <option
              v-for="item in lstDepartamento"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Municipio</label>
          <b-form-select
            v-model="city_id_filter"
            @change="getFilterWallet()"
            :disabled="zone_id_filter == null"
          >
            <template slot="first">
              <option :value="null">-- Seleccione --</option>
            </template>
            <option v-for="item in lstCiudad" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaDesde">Fec. entrega cartera desde</label>
          <b-form-input
            type="date"
            id="txtFechaDesde"
            v-model="range_task_management.startDate"
            :max="
              range_task_management.endDate == ''
                ? maxDate
                : range_task_management.endDate
            "
            @blur="changeDateTask()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col sm="2">
        <b-form-group>
          <label class="mb-0" for="txtFechaHasta">Fec. entrega cartera hasta</label>
          <b-form-input
            type="date"
            id="txtFechaHasta"
            v-model="range_task_management.endDate"
            :min="range_task_management.startDate"
            :max="maxDate"
            @blur="changeDateTask()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Avance</label>
          <b-form-select v-model="advance" @change="getAdvanceLevel()">
            <template slot="first">
              <option :value="null">-- Avance --</option>
            </template>
            <option v-for="item in lstAdvance" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label class="mb-0">Grado avance</label>
          <b-form-select
            v-model="advance_level"
            @change="getFilterWallet()"
            :disabled="advance == null"
          >
            <template slot="first">
              <option :value="null">-- Grado avance --</option>
            </template>
            <option
              v-for="item in lstAdvanceLevel"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <div class="card-group mb-4" v-if="false">
      <div class="card card-accent-primary">
        <div class="card-body">
          <div class="text-value">$ {{ formatPrice(summary.total_debt) }}</div>
          <small class="text-muted text-uppercase font-weight-bold"
            >Total cartera</small
          >
        </div>
      </div>
      <div class="card card-accent-success">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.capital_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >Total abonos a capital</small
          >
          <hr />
          <div class="text-value">
            $ {{ formatPrice(summary.total_agreements) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >Total acuerdos</small
          >
        </div>
      </div>

      <div class="card card-accent-warning">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.interests_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >Intereses recuperados</small
          >
          <hr />
          <div class="text-value">
            $ {{ formatPrice(summary.total_interests) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >Interés por recuperar</small
          >
        </div>
      </div>

      <div class="card card-accent-info">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.fees_recovered) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >Honorarios deudor cobrados</small
          >
          <hr />
          <div class="text-value">$ {{ formatPrice(summary.total_fees) }}</div>
          <small class="text-muted text-uppercase font-weight-bold"
            >Honorarios deudor por cobrar</small
          >
        </div>
      </div>
      <div class="card card-accent-danger">
        <div class="card-body">
          <div class="text-value">
            $ {{ formatPrice(summary.fees_customer) }}
          </div>
          <small class="text-muted text-uppercase font-weight-bold"
            >Total honorarios cliente</small
          >
        </div>
      </div>
    </div>

    <b-row>
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <div v-if="isAdmin">
              <div class="row" v-if="selectItems.length > 0">
                <div class="col-sm-2">
                  <downloadExcel
                    class="btn btn-warning col-sm-12 mb-2"
                    :data="selectItems"
                    worksheet="Indicadores"
                    name="indicators.xls"
                    :before-generate="startDownload"
                    :before-finish="finishDownload"
                    >Exportar</downloadExcel
                  >
                </div>
              </div>
            </div>

            <div>
              <b-table
                :hover="hover"
                :striped="striped"
                :bordered="bordered"
                :small="small"
                :fixed="fixed"
                responsive
                :items="items"
                :fields="fields"
                :current-page="currentPage"
                :per-page="perPage"
              >
                <template slot="HEAD_selected" v-if="isAdmin">
                  <input
                    type="checkbox"
                    @click.stop
                    v-model="selectAll"
                    @change="toggleSelectAll"
                  />
                </template>

                <template slot="selected" slot-scope="data" v-if="isAdmin">
                  <input
                    type="checkbox"
                    v-model="data.item.selected"
                    @change="selectRow(data.item)"
                  />
                </template>

                <template slot="created_at" slot-scope="data">{{
                  formatDateDescriotion(data.item.created_at)
                }}</template>

                <template slot="task_management_date" slot-scope="data">{{
                  formatDateDescriotion(data.item.task_management_date)
                }}</template>

                <template slot="wallet_prewritten" slot-scope="data">
                  <i
                    v-if="data.item.wallet_prewritten > 0"
                    class="fa fa-warning fa-lg text-danger"
                  ></i>
                  <i v-else class="fa fa-check-circle fa-lg text-success"></i>
                </template>

                <template slot="minimum_amounts" slot-scope="data">
                  <i
                    v-if="data.item.minimum_amounts"
                    class="fa fa-warning fa-lg text-danger"
                  ></i>
                  <i v-else class="fa fa-check-circle fa-lg text-success"></i>
                </template>

                <template
                  slot="commitments"
                  slot-scope="data"
                  class="text-center"
                  >{{ data.item.commitments }}</template
                >

                <template slot="prejury_total" slot-scope="data"
                  >${{ formatPrice(data.item.prejury_total) }}</template
                >
                <template slot="jury_total" slot-scope="data"
                  >${{ formatPrice(data.item.jury_total) }}</template
                >
                <template slot="extrajury_total" slot-scope="data"
                  >${{ formatPrice(data.item.extrajury_total) }}</template
                >

                <template slot="total" slot-scope="data"
                  >${{
                    formatPrice(data.item.prejury_total + data.item.jury_total)
                  }}</template
                >

                <template slot="actions" slot-scope="data" class="text-center">
                  <b-button
                    size="sm"
                    variant="primary"
                    class="mr-1 btn-custom-size"
                    @click="viewCustomer(data.item.customer_id)"
                    title="Ver cuenta"
                  >
                    <i class="fa fa-eye"></i>
                  </b-button>
                </template>

              </b-table>
            </div>
            <hr />
            <div class="row">
              <div class="col-sm-4">
                Mostrando
                {{
                  getRowCount(items) > perPage * currentPage
                    ? perPage * currentPage
                    : getRowCount(items)
                }}
                de {{ getRowCount(items) }} registros
              </div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    size="sm"
                    align="right"
                    :total-rows="getRowCount(items)"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker"; //https://github.com/Innologica/vue2-daterange-picker/blob/master/src/components/DateRangePicker.vue
import moment from "moment";
export default {
  name: "WalletIndicators",
  components: { DateRangePicker },
  props: {
    caption: {
      type: String,
      default: "ANÁLISIS DE ABONOS",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      auth: localStorage.getItem("auth"),
      isAdmin: localStorage.getItem("auth_is_admin") === "S" ? true : false,
      role_id: localStorage.getItem("role_id"), // PARA DETERMINAR EL ROL DEL USUARIO QUE INGRESA
      isCustomer: false,

      fields: [
        {
          key: "selected",
          name: "Selected",
          label: "",
          class: "options-column",
        },

        {
          key: "service_order_number",
          label: "Orden de servicio",
          sortable: true,
        },
        { key: "service_order_date", label: "Fecha ingreso", sortable: true },
        { key: "source_name", label: "Fuente", sortable: true },
        { key: "business_name", label: "Cliente", sortable: true },

        { key: "prejury_total", label: "Prejurídico", sortable: true },
        { key: "jury_total", label: "Jurídico", sortable: true },
        { key: "extrajury_total", label: "Extrajurídico", sortable: true },
        { key: "total", label: "Total", sortable: true },
        { key: "actions", name: "Opciones", label: "Opciones" },
      ],
      status: null,
      items: [],
      pagination: {},
      filter: null,
      tableData: [],
      tableHeader: [],
      errores: [],
      mostrarResumen: false,
      rowCount: -1,
      //
      selectItems: [],
      selectAll: false,
      // FILTROS DE BUSQUEDA

      maxDate: moment(String(new Date())).format("YYYY-MM-DD"),
      range_created_at: {
        startDate: moment(String(sumarDias(new Date(), -30))).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(String(new Date())).format("YYYY-MM-DD"),
      },
      range_task_management: {
        startDate: "", // moment(String(sumarDias(new Date(), -30))).format("YYYY-MM-DD"),
        endDate: "" // moment(String(new Date())).format("YYYY-MM-DD"),
      },

      staff_id_filter: null,
      business_name_filter: null,
      service_order_id_filter: null,
      source_id_filter: null,
      zone_id_filter: null,
      city_id_filter: null,

      advance: null,
      advance_level: null,

      // LISTAS PARA LOS FILTROS
      lstSource: [],
      lstServiceOrder: [],
      lstStaffs: [],
      lstDepartamento: [],
      lstCiudad: [],

      lstAdvance: [],
      lstAdvanceLevel: [],

      summary: {
        total_debt: 0,
        capital_recovered: 0,
        total_agreements: 0,
        interests_recovered: 0,
        total_interests: 0,
        fees_recovered: 0,
        total_fees: 0,
        fees_customer: 0,
      },

      // PAGINACIÓN DE VUE
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
    };
  },
  mounted() {
    this.initParameters();
    this.getFilterWallet();
  },
  computed: {},
  methods: {
    initParameters() {
      var auth = JSON.parse(localStorage.getItem("auth"));
      this.isCustomer = auth[0].customer_id != null ? true : false;
      this.staff_id_filter = this.role_id == 1 || this.role_id == 7 ? null : auth[0].staff_id;

      // 8: ORIGENES DE LA CUENTA
      this.$http.get(`${this.$urlApi}parameters/8?token=${this.token}`).then(
        (response) => {
          this.lstSource = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // ORDENES DE SERVICIO
      let staff_id = this.isAdmin ? null : auth[0].staff_id;

      this.$http
        .get(
          `${this.$urlApi}serviceorders/staff/${staff_id}/${this.role_id}?token=${this.token}`
        )
        .then(
          (response) => {
            this.lstServiceOrder = response.body.data;
            // console.log(response.body.data);
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );

      //LISTADO DE STAFF'S: 42: COMERCIAL
      this.$http.get(`${this.$urlApi}staffs/type/42?token=${this.token}`).then(
        (response) => {
          this.lstStaffs = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      //DEPARTAMENTOS DE COLOMBIA
      this.$http.get(`${this.$urlApi}zones/1?token=${this.token}`).then(
        (response) => {
          this.lstDepartamento = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

      // 4: AVANCE CLIENTE
      this.$http.get(`${this.$urlApi}parameters/4?token=${this.token}`).then(
        (response) => {
          this.lstAdvance = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );

    },
    changeDate() {
      if (
        this.range_created_at.startDate != "" &&
        this.range_created_at.endDate != ""
      ) {
        this.getFilterWallet();
      } else return;
    },
    getFilterWallet: function (urlPage) {
      let authAux = JSON.parse(this.auth);
      authAux[0].staff_id_filter = this.staff_id_filter;
      authAux[0].business_name_filter = this.business_name_filter;
      authAux[0].service_order_id_filter = this.service_order_id_filter;
      authAux[0].source_id_filter = this.source_id_filter;
      authAux[0].city_id_filter = this.city_id_filter;
      authAux[0].service_order_id_filter = this.service_order_id_filter;
      authAux[0].image = null;

      authAux[0].advance = this.advance;
      authAux[0].advance_level = this.advance_level;

      authAux[0].start_date = moment(this.range_created_at.startDate).format(
        "YYYY-MM-DD"
      );
      authAux[0].end_date = moment(this.range_created_at.endDate).format(
        "YYYY-MM-DD"
      );

      if (
        this.range_task_management.startDate != "" && this.range_task_management.startDate != null &&
        this.range_task_management.endDate != "" && this.range_task_management.endDate != null
      ) {
        authAux[0].start_date_task_management = moment(this.range_task_management.startDate).format("YYYY-MM-DD");
        authAux[0].end_date_task_management = moment(this.range_task_management.endDate).format("YYYY-MM-DD");
      }

      let url = `${this.$urlApi}customers/walletindicators?token=${this.token}`;
      showLoader();
      this.$http
        .post(url, JSON.stringify(authAux), {
          headers: { "Content-Type": "application/json" },
        })
        .then(
          function (response) {
            console.log(response);
            this.items = response.data.data;
            // this.summary = response.data.summary;
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    startDownload() {
      showLoader();
    },
    finishDownload() {
      hideLoader();
    },
    selectRow(item) {
      if (!item.selected) {
        if (this.selectAll) {
          this.selectAll = false;
        }
        var index = this.selectItems.indexOf(item);

        if (index > -1) {
          this.selectItems.splice(index, 1);
        }
      } else {
        this.selectItems.push(item);
      }
      //console.log(this.selectItems)
    },
    toggleSelectAll() {
      if (this.selectAll) {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = true;
          this.$set(this.items, i, updatingItem);
          this.selectItems.push(updatingItem);
        }
      } else {
        for (var i = 0; i < this.items.length; i++) {
          var updatingItem = this.items[i];
          updatingItem.selected = false;
          this.$set(this.items, i, updatingItem);
        }
        this.selectItems = [];
      }
      //console.log(this.selectItems)
    },
    formatDateDescriotion(value) {
      if (!value) return "";
      else {
        if (value == "--") return value;
        else {
          var d = moment(value).format("DD");
          var m = moment(value).format("MMM");
          var a = moment(value).format("YYYY");
          return d + " de " + m + " " + a;
        }
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    getRowCount(items) {
      return items.length;
    },
    getCitiesByZone(zone_id) {
      this.city_id_filter = null;
      if (zone_id) {
        showLoader();
        this.$http
          .get(`${this.$urlApi}cities/${zone_id}?token=${this.token}`)
          .then(
            (response) => {
              this.lstCiudad = response.data.data;

              hideLoader();
            },
            (error) => {
              console.log(error);
            }
          );
      }
      this.getFilterWallet();
    },
    viewCustomer(customer_id) {
      let url = `${location.origin}/#/customers/view/${customer_id.toString()}`;
      window.open(url, "_blank");
    },
    getAdvanceLevel() {
      this.advance_level = null;
      this.getFilterWallet();

      this.$http
        .get(
          `${this.$urlApi}parameters/advance/${this.advance}?token=${this.token}`
        )
        .then(
          (response) => {
            this.lstAdvanceLevel = response.data.data;
          },
          (error) => {
            console.log(error);
          }
        )
    },
    changeDateTask() {
      if (
        this.range_task_management.startDate != "" && this.range_task_management.startDate != null &&
        this.range_task_management.endDate != "" && this.range_task_management.endDate != null
      ) {
        this.getFilterWallet();
      } else return;
    },
  }
};
</script>
